type DeviationInfoProps = {
  value: string;
  isNegative: boolean;
};

export const DeviationInfo = ({ value, isNegative }: DeviationInfoProps) => (
  <span
    className={`w-max block py-0.5 px-1 rounded-sm text-s-sb ${isNegative ? 'bg-success-90 text-success-30' : 'bg-danger-90 text-danger-30'}`}
  >
    {`${isNegative ? '-' : '+'}${value}`}
  </span>
);
